module.exports = __webpack_public_path__ + "img/banner6.65992609.png";